import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { removeAuthToken, removeUserInfo } from '../utils/auth';

/**
 * 토큰 만료 시간을 체크하고 만료 시 로그아웃 처리하는 훅
 */
const useTokenExpiry = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkTokenExpiry = () => {
      const expiresAt = localStorage.getItem('tokenExpiresAt');
      
      if (expiresAt) {
        const now = Date.now();
        const expiryTime = parseInt(expiresAt);
        
        // 토큰이 만료되었으면 로그아웃
        if (now > expiryTime) {
          console.log('토큰이 만료되어 로그아웃합니다.');
          removeAuthToken();
          removeUserInfo();
          localStorage.removeItem('tokenExpiresAt');
          navigate('/login');
        }
      }
    };

    // 1분마다 토큰 만료 시간 체크
    const interval = setInterval(checkTokenExpiry, 60000);
    
    // 초기 체크
    checkTokenExpiry();

    return () => clearInterval(interval);
  }, [navigate]);
};

export default useTokenExpiry;

